exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-form {\n  max-width: 700px;\n  display: inline-block;\n  text-align: left;\n}\n.login-form__forgot {\n  float: right;\n}\n.login-form__error-msg {\n  margin-bottom: 16px;\n}\n", ""]);

// exports
